var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch",class:{ checked: _vm.checked },on:{"click":function($event){return _vm.$emit('switch', !_vm.checked)}}},[_c('div',[_c('Icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.checked),expression:"checked"}],attrs:{"icon":"icon-check"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }